import { commCgi, mock } from '@tencent/Coa';
import * as eggMock from '@/services/mocks/egg';
import scene from '@/services/mocks/scene';
var actId = window.setting.活动Id; // 获取用户的彩蛋信息，如彩蛋类型，数量

export function getEggInfo() {
  return commCgi([mock(eggMock.有蛋, scene.正常碰蛋), mock(eggMock.今天没蛋了, scene.今天没蛋了), mock(eggMock.主人蛋不足, scene.对方没蛋了)])({
    name: 'spp_fulishe_eggs_index',
    cmd: 2,
    actid: actId
  });
}
export function receiveEgg() {
  return commCgi({
    name: 'fulishe_eggs_adapter',
    cmd: 1,
    actid: actId
  });
} // 碰蛋记录

export function getMyRecord() {
  return commCgi([mock(eggMock.碰蛋记录, scene.碰蛋记录)])({
    name: 'spp_fulishe_eggs_index',
    cmd: 4,
    actid: actId
  });
} // 获取个人碰蛋未读消息

export function getUnReadAwardList() {
  return commCgi([mock(eggMock.碰蛋消息, scene.碰蛋消息)])({
    name: 'spp_fulishe_eggs_index',
    cmd: 5,
    actid: actId
  });
} // 获取分享码

export function getShareCode() {
  return commCgi([// mock({ ret: -1002, msg: '当前活动未发布' })
  ])({
    name: 'spp_fulishe_eggs_collision',
    cmd: 65391,
    actid: actId
  });
} // 根据分享码获取蛋信息

export function getInfoByShareCode(shareCode) {
  return commCgi([mock(eggMock.今天还未碰蛋, [scene.正常碰蛋, scene.碰蛋出错, scene.我没中奖, scene.今天没蛋了, scene.对方没中奖]), mock(eggMock.今天已经碰过, scene.今天已经碰过)])({
    name: 'spp_fulishe_eggs_collision',
    cmd: 65393,
    share_code: shareCode
  });
} // 碰蛋

export function bumpEgg(shareCode) {
  return commCgi([mock(eggMock.碰蛋成功, scene.正常碰蛋), mock(eggMock.碰蛋出错, scene.碰蛋出错), mock(eggMock.碰蛋自己没中奖, scene.我没中奖), mock(eggMock.碰蛋对方没中奖, scene.对方没中奖)])({
    name: 'spp_fulishe_eggs_collision',
    cmd: 65394,
    share_code: shareCode
  });
} // 获取加蛋记录

export function getEggSourceList() {
  return commCgi({
    name: 'spp_fulishe_eggs_index',
    cmd: 3,
    actid: actId
  });
} // 获取任务列表

export function getMissionList() {
  return commCgi({
    name: 'spp_fulishe_eggs_index',
    cmd: 1,
    actid: actId
  });
}